import { Home } from './Home';
import { Shop } from './Shop';
import { OrderHistory } from './OrderHistory';
// import { Checkout } from './Checkout';
import { OrderSuccessful } from './OrderSuccessful';
import { Menu } from './Menu';
import { PlacedOrders } from './PlacedOrders'
import { OrderDetails } from './OrderDetails'
import { ViewOrder } from './ViewOrder'


export const screens = {

  Home,
  Menu,
  Shop,
  OrderHistory,
  // Checkout,
  OrderSuccessful,
  PlacedOrders,
  OrderDetails,
  ViewOrder

}
